import { render, staticRenderFns } from "./FacialRecognition.vue?vue&type=template&id=0dca82db&scoped=true"
import script from "./FacialRecognition.vue?vue&type=script&lang=js"
export * from "./FacialRecognition.vue?vue&type=script&lang=js"
import style0 from "@pds/core/core.min.css?vue&type=style&index=0&id=0dca82db&prod&scoped=true&lang=css&external"
import style1 from "./FacialRecognition.vue?vue&type=style&index=1&id=0dca82db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca82db",
  null
  
)

export default component.exports